export const SHOW_CONTACT_SALES_FORM_MODAL = 'show-contact-sales-form-modal';
export const SHOW_CONTACT_SUPPORT_FORM_MODAL =
  'show-contact-support-form-modal';
export const HAS_SUBMITTED_CONTACT_FORM = 'has-submitted-sales-form';

export const showContactSalesFormModal = (
  showSalesFormModal,
  selectedPlan = 'unspecified'
) => {
  return {
    type: SHOW_CONTACT_SALES_FORM_MODAL,
    showSalesFormModal,
    selectedPlan,
  };
};

export const showContactSupportFormModal = (
  showSupportFormModal,
  ticketSubject,
  initialMessage
) => {
  return {
    type: SHOW_CONTACT_SUPPORT_FORM_MODAL,
    showSupportFormModal,
    ticketSubject,
    initialMessage,
  };
};

export const setHasSubmittedContactForm = () => {
  return {
    type: HAS_SUBMITTED_CONTACT_FORM,
  };
};
